import ordersStockStore from '@/Store/ordersStock'
import { upsertOrders } from './mutations'

export default {
  inject: ['systemStatus'],

  data: () => ({
    submittingOrders: 0,
    errorOnSubmit: false,
    errorBag: []
  }),

  methods: {
    /**
     *
     */
    async submitOrders() {
      const data = ordersStockStore.mapStockForUpsertMutation(this.systemStatus.next_order_day)
      this.submittingOrders++

      try {
        await this.$apollo.mutate({
          mutation: upsertOrders,
          variables: {
              orders: data,
              year: this.year,
              week: this.weekNumber,
          }
        })

        window.location.reload()
      } catch (error) {
        this.errorOnSubmit = true
        this.errorBag = error.graphQLErrors
        console.error(error.graphQLErrors)
      }

      this.submittingOrders--
    },
  }
}
